import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How can marketing help my dental clinic grow?",
    a: "Marketing helps your dental clinic show up when patients search on Google, build trust through reviews and content, and turn interest into scheduled appointments. A focused system replaces inconsistent referrals with a predictable flow of new patients.",
  },
  {
    q: "What makes N. Santiago Media different from other dental marketing agencies?",
    a: "We combine dental practice operations experience with marketing strategy. Most agencies focus on deliverables. We focus on patient flow — visibility, trust, and conversion. Every system we build is designed to help your clinic turn attention into scheduled appointments.",
  },
  {
    q: "Do you only work with dental clinics?",
    a: "Our primary focus is dental clinics. We also support select local service-based businesses that need stronger visibility, trust, and conversion systems.",
  },
  {
    q: "How long does it take to see results?",
    a: "It depends on where your clinic is starting. Paid campaigns can generate interest quickly. Local SEO and reputation systems typically show measurable improvements within 3–6 months, with results compounding as visibility and trust grow. We set clear expectations during your audit.",
  },
  {
    q: "What is included in a Dental Growth Audit?",
    a: "A no-obligation review of your Google presence, website, reviews, content, competitor positioning, and patient journey. We identify where visibility, trust, or conversion is breaking down and give you a clear plan to fix it, whether you work with us or not.",
  },
];

const faqVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, delay: i * 0.08, ease: "easeOut" as const },
  }),
};

const FAQSection = () => {
  return (
    <section id="faq" className="section-padding section-light">
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-primary font-semibold tracking-[0.2em] uppercase text-sm mb-4">
            Common Questions
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl mb-4 text-graphite">Frequently Asked Questions</h2>
          <p className="text-muted-foreground text-lg">
            Answers to the most common questions about working with N. Santiago Media.
          </p>
        </motion.div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <motion.div
              key={i}
              custom={i}
              variants={faqVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
            >
              <AccordionItem value={`faq-${i}`} className="card-glass-light px-6 border-none">
                <AccordionTrigger className="text-left font-heading text-base text-graphite hover:text-primary transition-colors py-5">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm leading-relaxed pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            </motion.div>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
